import React, { useState } from 'react';
import ContactForm from '../../components/ContactPage/ContactForm';
import BranchCard from '../../components/ContactPage/BranchCard';
import CityFilter from '../../layouts/CityFilter';
import ContactHeader from '../../layouts/ContactHeader';
import { branches, commonContact } from '../../data/contactData';

const Contact = () => {
  const [expandedBranch, setExpandedBranch] = useState(1);
  const [activeCity, setActiveCity] = useState('All');

  const cities = ['All', ...new Set(branches.map(branch => branch.city))];
  
  const filteredBranches = activeCity === 'All' 
    ? branches 
    : branches.filter(branch => branch.city === activeCity);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <ContactHeader {...commonContact} />

        <div className="grid grid-cols-1 gap-12">
          <ContactForm />

          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-10 items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-800">Our Branches</h2>
              <CityFilter
                cities={cities}
                activeCity={activeCity}
                onCityChange={setActiveCity}
              />
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {filteredBranches.map(branch => (
                <BranchCard
                  key={branch.id}
                  branch={branch}
                  isExpanded={expandedBranch === branch.id}
                  onToggle={() => setExpandedBranch(
                    expandedBranch === branch.id ? null : branch.id
                  )}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;